import React, { FunctionComponent } from 'react';
import FacebookShare from '../SocialButtons/FacebookShare';
import { DonateButton } from '..';

export type FundraisingCTAProps = {
  shareUrl: string;
};

const FundraisingCTA: FunctionComponent<FundraisingCTAProps> = ({
  shareUrl,
}) => (
  <>
    <DonateButton
      key="donateButton"
      className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm@lg"
      trackingDataPageSection="FundraisingCTA"
    />
    <FacebookShare key="facebookShare" url={shareUrl} />
  </>
);

export default FundraisingCTA;
